import { useEffect, useState } from "react";
import { GET_CITY_BY_API } from "../api/apiPath";
import http from "../api/server";

const useGetCity = () => {
  const [cityList, setCityList] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCityList = async () => {
      try {
        setLoading(true);
        const response = await http.get(
          GET_CITY_BY_API 
        );
        if (response.status !== 200) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        setCityList(response?.data); // Assuming the API returns an object with an 'Client ID' property
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchCityList();
  },[]);

  return { cityList, loading, error };
};

export default useGetCity;
